import { useLocation } from '@tanstack/react-router';

const notificationEnabledPaths = [
  'tasks',
  'receiving',
  'ops-receiving',
  'shrinkage',
  'inventory-adjustments',
  'stock-count',
  'bin-locations',
  'product-average-weight',
  'venue-settings',
];

export const useIsTaskNotificationEnabledPath = () => {
  const pathname = useLocation({ select: (location) => location.pathname });

  const isPathEnabled = notificationEnabledPaths.some((enabledPath) =>
    pathname.startsWith(`/${enabledPath}`),
  );

  return isPathEnabled;
};
